import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Handles the OAuth callback redirect.
 * Reads access_token and refresh_token from the URL hash fragment,
 * stores them in localStorage, and redirects to the dashboard.
 */
export default function OAuthCallbackPage() {
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    const hash = window.location.hash.substring(1); // remove leading #
    const params = new URLSearchParams(hash);
    const accessToken = params.get('access_token');
    const refreshToken = params.get('refresh_token');

    if (accessToken) {
      localStorage.setItem('kog_access_token', accessToken);
      if (refreshToken) {
        localStorage.setItem('kog_refresh_token', refreshToken);
      }
      // Clear the hash from the URL for cleanliness
      window.history.replaceState(null, '', '/');
      navigate('/', { replace: true });
    } else {
      setError('Google sign-in failed. No token received.');
    }
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center"
        style={{ background: 'var(--bg-primary)' }}>
        <div className="text-center">
          <p className="text-sm mb-4" style={{ color: 'var(--error)' }}>{error}</p>
          <a href="/login" className="text-sm underline" style={{ color: 'var(--netrun-green)' }}>
            Back to login
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center"
      style={{ background: 'var(--bg-primary)' }}>
      <p className="text-sm" style={{ color: 'var(--text-muted)' }}>Signing in...</p>
    </div>
  );
}
